import { ArrowRight, Building2, Home, Landmark, KeyRound } from "lucide-react";
import { Link } from "react-router-dom";

const JOURNEY_CARDS = [
  {
    key: "buy",
    label: "Buy",
    title: "Buy a Property",
    body: "Explore curated homes and investment-ready opportunities with cleaner market context.",
    href: "/buy",
    icon: Home,
  },
  {
    key: "rent",
    label: "Rent",
    title: "Rent a Home",
    body: "Find rental options faster with cleaner filters and a direct response path.",
    href: "/rent",
    icon: KeyRound,
  },
  {
    key: "sell",
    label: "Sell",
    title: "Sell My Property",
    body: "Get valuation guidance and seller positioning support before taking your property live.",
    href: "/sell",
    icon: Landmark,
  },
  {
    key: "lease-out",
    label: "Lease Out",
    title: "Lease Out My Unit",
    body: "Plan rental pricing and get landlord support before listing your unit.",
    href: "/lease-out",
    icon: Building2,
  },
];

export const ConsumerJourneyGrid = ({ buildBrandedPath }) => (
  <section className="section-shell pt-8" data-testid="consumer-lifecycle-section" id="consumer-lifecycle-section">
    <div>
      <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#8b6d16]">Choose Your Path</p>
      <h2 className="mt-3 text-4xl font-semibold leading-tight text-[#0C285A] md:text-5xl" data-testid="consumer-lifecycle-heading">
        Choose what you want to do next.
      </h2>
      <p className="mt-4 max-w-3xl text-sm leading-8 text-[#42566f] md:text-base" data-testid="consumer-lifecycle-copy">
        Browse, shortlist, request guidance, and move into action from one cleaner SGPropPortal property flow.
      </p>
    </div>

    <div className="mt-8 grid gap-5 lg:grid-cols-2 xl:grid-cols-4" data-testid="consumer-lifecycle-grid">
      {JOURNEY_CARDS.map((card) => {
        const Icon = card.icon;
        return (
          <Link
            className="rounded-[28px] border border-[#D7C39A]/36 bg-[#FFFDF7] p-6 shadow-[0_18px_50px_rgba(12,40,90,0.05)] transition duration-300 hover:-translate-y-1 hover:border-[#B8860B]/28 hover:shadow-[0_24px_60px_rgba(12,40,90,0.1)]"
            data-testid={`consumer-path-${card.key}-card`}
            key={card.key}
            to={buildBrandedPath(card.href)}
          >
            <div className="flex items-center gap-3">
              <div className="rounded-full border border-[#D7C39A]/36 bg-[#FFF4DB] p-3 text-[#8b6d16]">
                <Icon className="h-5 w-5" />
              </div>
              <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-[#8b6d16]">{card.label}</p>
            </div>
            <h3 className="mt-5 text-2xl font-semibold leading-tight text-[#0C285A]">{card.title}</h3>
            <p className="mt-4 text-sm leading-7 text-[#42566f]">{card.body}</p>
            <span className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-[#0C285A]">
              {card.key === "buy" ? "Browse Homes" : card.key === "rent" ? "Explore Rentals" : card.key === "sell" ? "Start Selling" : "Lease Out My Property"} <ArrowRight className="h-4 w-4" />
            </span>
          </Link>
        );
      })}
    </div>
  </section>
);